import { Tag as AntTag } from 'antd'
import type { ComponentProps } from 'react'

type AntTagProps = ComponentProps<typeof AntTag>

export interface AppTagProps extends AntTagProps {}

export const AppTag = (props: AppTagProps) => <AntTag {...props} />

export const AppCheckableTag = AntTag.CheckableTag
